export { SmallGoldenCard } from './SmallGoldenCard';
